import InputSearchPopup from "./InputSearchPopup";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { SEARCH_TYPE } from "constants/constants";
import { useRef, useState, useEffect } from "react";
import ErrorPopupBtn from "components/alert-popup/ErrorPopupBtn";
import { ErrorPopup } from "components/alert-popup/ErrorPopup";

const InputSearchList = ({
  inputSearchPopupMaxHeight,
  errors,
  getOptions,
  label,
  limitChoice,
  minLength,
  options,
  placeholder,
  popup,
  readOnly,
  required,
  selectedOptions,
  setValue,
  onChangeInput,
  id,
  isBo = false,
  isTable,
  dataTestId,
  ...props
}) => {
  const inputRef = useRef(null);
  const intl = useIntl();
  const [inputSearch, setInputSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [isOpened, setIsOpened] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const onChange = (e) => {
    setInputSearch(e.target.value);
    setSelected([]);
    setValue([]);
    if (minLength === 0 || inputSearch.length >= minLength) {
      setIsOpened(true);
    } else {
      setIsOpened(false);
    }
    if (onChangeInput) {
      onChangeInput(e.target.value);
    }
  };

  useEffect(() => {
    if (minLength > 0 && inputSearch?.length > minLength) {
      getOptions(inputSearch);
    }
  }, [inputSearch]);

  useEffect(() => {
    if (selectedOptions?.length > 0) setSelected(selectedOptions);
    else setSelected([]);
  }, [selectedOptions]);

  return (
    <>
      {isOpened && (
        <button
          className="input-search-close button-style"
          onClick={() => setIsOpened(!isOpened)}
        />
      )}
      <div
        className={`input-search ${isBo ? "is-bo" : ""} ${
          isBo && errors?.isMissingValue ? "is-bo-error" : ""
        }  `}
        ref={inputRef}
      >
        <div
          className="overlap-group"
          style={{ flexDirection: label ? "column" : "unset" }}
        >
          {label && (
            <label
              className={`label sourcesanspro-normal-shadow-blue-14px ${
                errors?.ref ? "label-error" : "label-standard"
              }`}
            >
              <FormattedMessage {...label} />
              {required && "*"}
              {(errors?.ref || errors?.message) && (
                <ErrorPopupBtn setShowErrorPopup={setShowErrorPopup} />
              )}
            </label>
          )}
          <div
            className={`${
              !isTable ? "is-table" : ""
            } sourcesanspro-normal-gray-suit-18px display-inputs-flex`}
          >
            <input
              type="text"
              className="input-placeholder sourcesanspro-normal-gray-suit-18px"
              value={inputSearch || selected[0]?.label || "" || selected}
              placeholder={placeholder ? intl.formatMessage(placeholder) : ""}
              onChange={onChange}
              disabled={readOnly}
              id={`input-search-list-${id}`}
              data-testid={dataTestId}
            />
          </div>
        </div>
      </div>
      {isOpened && (
        <InputSearchPopup
          defaultOptions={options}
          title={popup.title}
          inputValue={inputSearch}
          setInputValue={setInputSearch}
          limit={limitChoice}
          selectedOptions={selected}
          getSelectedOptions={(sel) => {
            setInputSearch("");
            if (sel.length === 0) {
              setValue([]);
            } else {
              setValue(sel);
            }
          }}
          readOnly={readOnly}
          searchType={SEARCH_TYPE.ARRAY}
          hide={() => setIsOpened(!isOpened)}
          inputSearchPopupMaxHeight={inputSearchPopupMaxHeight}
        />
      )}
      {showErrorPopup && (
        <ErrorPopup
          errors={props.errors}
          showErrorPopup={showErrorPopup}
          setShowErrorPopup={setShowErrorPopup}
          label={label}
          errorMessage={
            props?.errorMessage ||
            (inputSearch && selected.length === 0 && "select_value_from_list")
          }
          errorValue={props?.errorValue}
        />
      )}
    </>
  );
};

InputSearchList.propTypes = {
  errors: PropTypes.any,
  label: PropTypes.object,
  limitChoice: PropTypes.number,
  minLength: PropTypes.number,
  onDelete: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.any,
  popup: PropTypes.any.isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  selectedOptions: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  type: PropTypes.string,
  getOptions: PropTypes.func,
  onChangeInput: PropTypes.func,
  id: PropTypes.string,
  isBo: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  inputSearchPopupMaxHeight: PropTypes.number,
  isTable: PropTypes.bool,
};
InputSearchList.defaultProps = {
  errors: null,
  label: null,
  limitChoice: 1,
  minLength: 0,
  onDelete: null,
  options: [],
  placeholder: null,
  readOnly: false,
  required: false,
  selectedOptions: [],
  type: "",
  getOptions: null,
  onChangeInput: null,
  id: "",
  value: [],
  inputSearchPopupMaxHeight: null,
};

export default InputSearchList;
